import React from 'react';

// TODO: We should move these components into the CL if we want Safelist to be independent from WF.
import List from 'shared/components/List';

import { getDictionaryValues } from '../../utilities';

import { RedactableTerm } from './RedactableTerm';
import { InEditRedactableTerm } from './RedactableTerm/RedactableTerm';
import { RedactableTermItemsProps } from './types';

const RedactableTermItems = ({
  className,
  termDictionary,
  onSelect,
  onUpdateTerm,
  onEditTerm,
  onRemoveTerm,
}: RedactableTermItemsProps) => (
  <List
    className={className}
    itemSeparation={8}
    items={getDictionaryValues(termDictionary)}
    renderItem={({ term, isSelected, isBeingEdited }) => (
      isBeingEdited ?
        <InEditRedactableTerm
          term={term}
          onSaveEdit={onUpdateTerm}
          onCancelEdit={onEditTerm}
        /> :
        <RedactableTerm
          term={term}
          isSelected={isSelected}
          onSelect={onSelect}
          onEditTerm={onEditTerm}
          onRemoveTerm={onRemoveTerm}
        />
    )}
  />
);

export { RedactableTermItems };
